import jump from 'jump.js'

export default buildCollectionJump => {
  const jumpLink = document.querySelector('.build-cta')
  jumpLink.addEventListener('click', () => {
    jump('.collection-container', {
      offset: -150
    })
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/build-collection-jump.js